export function formatCardNumber(
  cardNumber: string | undefined | null
): null | string {
  const fourDigitChunks: null | string[] = (cardNumber || '').match(/\d{1,4}/g);
  return fourDigitChunks && fourDigitChunks.join(' ');
}

export function trimCardNumber(cardNumber = ''): string {
  return cardNumber.replace(/\s/g, '');
}

export function isCardNumber(cardNumber = ''): boolean {
  return Boolean(trimCardNumber(cardNumber).match(/\d{16}/));
}
